<script>
	let { 
		input,
		// list,
    children,
		index = $bindable(0),
		items = $bindable([]),
		onSelect,
		onEscape
	} = $props()

	let handlers = {
		onkeydown: onKeyDown,
		oninput: onInput
	}
	
	function handleUpKey(e) {
    e.preventDefault()
    e.stopPropagation()
    index = Math.max(index - 1, -1)
  }

  function handleDownKey(e) {
    e.preventDefault()
    e.stopPropagation()
    index = Math.min(index + 1, items.length - 1)
  }

	function handleEnterKey(e) {
		e.preventDefault()
		e.stopPropagation()
    if (index === -1) return
		onSelect?.({ index, item: items[index]})
	}

	function handleEscapeKey() {
		onEscape?.()
	}

	function onKeyDown(e) {
    if (e.key === "ArrowUp") {
      handleUpKey(e)
    } else if (e.key === "ArrowDown") {
      handleDownKey(e)
    } else if (e.key === "Enter") {
      handleEnterKey(e)
    } else if (e.key === "Escape") {
      handleEscapeKey(e)
    }
	}

	function onInput() {
		index = 0
	}
</script>

{@render input?.(handlers)}

{@render children?.({ index })}